<script setup lang="ts">
import { RouterView } from 'vue-router'
</script>

<template>
  <RouterView v-slot="{ Component, route }">
    <!-- Key on `path` only, not `fullPath`. fullPath includes the
         query string, so syncing a filter to the URL was remounting
         the entire page on every keystroke and stealing focus. -->
    <component :is="Component" :key="route.path" />
  </RouterView>
</template>
